import { NSTable } from 'bricks';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import { IUnitMix } from 'views/ProFormaSetup/types';
import { TotalGrossRent } from 'views/ProFormaTable/types';
import './InvestmentMemoUnitMixTable.scss';

interface Props {
    unitMixes: IUnitMix[];
    totals: TotalGrossRent;
}

const InvestmentMemoUnitMixTable = ({ unitMixes, totals }: Props) => (
    <div className="InvestmentMemoUnitMixTable">
        <div className="text-primary ml-2 mt-2 pb-0">UNIT MIX</div>
        <NSTable className="NSTable mb-0 mx-0 px-0">
            <thead className="NSTable__thead">
                <tr className="NSTable__thead__tr">
                    <th className="NSTable__thead__tr__th pb-1 text-left text-dark">Unit type</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">Count</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">Avg SF</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">Rent/unit/mo</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">Pro forma rent</th>
                </tr>
            </thead>
            <tbody className="NSTable__tbody">
                {unitMixes.map(unitMix => (
                    <tr key={`unit-mix-${unitMix.id}`} className="NSTable__tbody__tr">
                        <td className="NSTable__tbody__tr__td py-1 text-left">{unitMix.name}</td>
                        <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                            {unitMix.units?.toLocaleString() ?? '-'}
                        </td>
                        <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                            {unitMix.averageSquareFootage?.toLocaleString() ?? '-'}
                        </td>
                        <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                            {unitMix.valuePerUnitPerMonth != null
                                ? numeralFormatterCurrency(unitMix.valuePerUnitPerMonth, '$0,0')
                                : '-'}
                        </td>
                        <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                            {unitMix.amountPerYear != null
                                ? numeralFormatterCurrency(unitMix.amountPerYear, '$0,0')
                                : '-'}
                        </td>
                    </tr>
                ))}
                <tr className="NSTable__tbody__tr">
                    <td className="NSTable__tbody__tr__td pt-1 text-left">Total/avg</td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.totalUnits?.toLocaleString() ?? '-'}
                    </td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.averageSf?.toLocaleString() ?? '-'}
                    </td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.pricePerUnit != null
                            ? numeralFormatterCurrency(totals.pricePerUnit, '$0,0')
                            : '-'}
                    </td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.totalAmountPerYear != null
                            ? numeralFormatterCurrency(totals.totalAmountPerYear, '$0,0')
                            : '-'}
                    </td>
                </tr>
            </tbody>
        </NSTable>
    </div>
);

export default InvestmentMemoUnitMixTable;
